import API from '../api/api';
import { _exportDownloadLinkDecorator, _getAttributeProgress } from '../helper';
import cloneDeep from 'lodash/cloneDeep';

const LOAD_APPINTEGRATION_DEFINITIONS_RESET_QUERY = 'LOAD_APPINTEGRATION_DEFINITIONS_RESET_QUERY';
const LOAD_APPINTEGRATION_DEFINITIONS_PENDING = 'LOAD_APPINTEGRATION_DEFINITIONS_PENDING';
const LOAD_APPINTEGRATION_DEFINITIONS_RESPONSE = 'LOAD_APPINTEGRATION_DEFINITIONS_RESPONSE';

const LOAD_APPINTEGRATIONS_RESET_QUERY = 'LOAD_APPINTEGRATIONS_RESET_QUERY';
const LOAD_APPINTEGRATIONS_PENDING = 'LOAD_APPINTEGRATIONS_PENDING';
const LOAD_APPINTEGRATIONS_RESPONSE = 'LOAD_APPINTEGRATIONS_RESPONSE';

const LOAD_APPINTEGRATION_PENDING = 'LOAD_APPINTEGRATION_PENDING';
const LOAD_APPINTEGRATION_RESPONSE = 'LOAD_APPINTEGRATION_RESPONSE';

const SAVE_APPINTEGRATIONS_PENDING = 'SAVE_APPINTEGRATIONS_PENDING';
const SAVE_APPINTEGRATIONS_PROGRESS = 'SAVE_APPINTEGRATIONS_PROGRESS';
const SAVE_APPINTEGRATIONS_RESPONSE = 'SAVE_APPINTEGRATIONS_RESPONSE';

const RESET_ERRORS = 'RESET_ERRORS';
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS';


const LOAD_PARTNERS_PENDING = 'LOAD_PARTNERS_PENDING';
const LOAD_PARTNERS_RESPONSE = 'LOAD_PARTNERS_RESPONSE';

const LOAD_PARTNER_INTEGRATION_PENDING = 'LOAD_PARTNER_INTEGRATION_PENDING';
const LOAD_PARTNER_INTEGRATION_RESPONSE = 'LOAD_PARTNER_INTEGRATION_RESPONSE';

const SAVE_PARTNER_APIKEY_PENDING = 'SAVE_PARTNER_APIKEY_PENDING';
const SAVE_PARTNER_APIKEY_RESPONSE = 'SAVE_PARTNER_APIKEY_RESPONSE';

const DELETE_PARTNER_APIKEY_PENDING = 'DELETE_PARTNER_APIKEY_PENDING';
const DELETE_PARTNER_APIKEY_RESPONSE = 'DELETE_PARTNER_APIKEY_RESPONSE';

const ACTIVATE_PARTNER_INTEGRATION_PENDING = 'ACTIVATE_PARTNER_INTEGRATION_PENDING';
const ACTIVATE_PARTNER_INTEGRATION_RESPONSE = 'ACTIVATE_PARTNER_INTEGRATION_RESPONSE';

const DEACTIVATE_PARTNER_INTEGRATION_PENDING = 'DEACTIVATE_PARTNER_INTEGRATION_PENDING';
const DEACTIVATE_PARTNER_INTEGRATION_RESPONSE = 'DEACTIVATE_PARTNER_INTEGRATION_RESPONSE';


const initialState = {
  load_appintegration_definitions_pending: false,
  load_appintegrations_pending: false,
  load_appintegration_pending: false,
  save_appintegrations_pending: false,
  appintegration_definitions: [],
  appintegrations: [],
  progress: 0,
  page_info: null,
  cursor: null,
  definitions_page_info: null,
  definitions_cursor: null,
  error: false,
  saveErrors: [],
  permissionUpdateNeeded: false,

  load_partners_pending: false,
  load_partner_integration_pending: false,
  save_partner_apikey_pending: false,
  delete_partner_apikey_pending: false,
  activate_partner_integration_pending: false,
  deactivate_partner_integration_pending: false,
  partners: [],
  partnerIntegration: null,
  partnerIntegrationError: null,
  loadingPartnerSlug: null,
};

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_APPINTEGRATIONS_RESET_QUERY: {
      return {
        ...state,
      };
    }
    case LOAD_APPINTEGRATIONS_PENDING: {
      return {
        ...state,
        load_appintegrations_pending: true,
      };
    }
    case LOAD_APPINTEGRATIONS_RESPONSE: {
      if (action.response.success === true) {
        const newAppIntegrations = [];
        for(const key in action.response.result) {
          if (action.response.result.hasOwnProperty(key)) {
            let appIntegration = action.response.result[key][0];
            newAppIntegrations.push({
              id: `${appIntegration.app_name}-${appIntegration.block_name}`,
              gid: appIntegration.gid,
              title: `${appIntegration.app_name.replace(/-/g, ' ')} - ${appIntegration.block_name.replace(/-/g, ' ')}`,
              fields: [],
            });
          }
        }
        return {
          ...state,
          load_appintegrations_pending: false,
          appintegrations: newAppIntegrations,
        };
      } else {
        return {
          ...state,
          load_appintegrations_pending: false
        };
      }
    }

    case LOAD_APPINTEGRATION_PENDING: {
      return {
        ...state,
        load_appintegration_pending: true,
      };
    }
    case LOAD_APPINTEGRATION_RESPONSE: {
      if (action.response.success === true) {
        const newAppIntegrations = cloneDeep(state.appintegrations);
        let appIntegrationToUpdate = newAppIntegrations.find((x) => x.gid.includes(action.appIntegrationId));

        if (!appIntegrationToUpdate) {
          appIntegrationToUpdate = {
            gid: `gid://shopify/AppIntegration/${action.appIntegrationId}`,
            id: action.appIntegrationId,
            display_name: action.response.appintegration.display_name,
          };
          newAppIntegrations.push(appIntegrationToUpdate);
        }

        appIntegrationToUpdate.translations = cloneDeep(action.response.result.translations);
        appIntegrationToUpdate.synchronized = true;
        appIntegrationToUpdate.progress = _getAttributeProgress(action.response.result.translations, 'target');

        return {
          ...state,
          load_appintegration_pending: false,
          appintegrations: newAppIntegrations,
        };
      } else {
        return {
          ...state,
          load_appintegration_pending: false,
        };
      }
    }

    case SAVE_APPINTEGRATIONS_PENDING: {
      return {
        ...state,
        save_appintegrations_pending: true,
        saveErrors: null,
      };
    }
    case SAVE_APPINTEGRATIONS_PROGRESS: {
      if (!action.item) {
        return {
          ...state,
          progress: action.progress,
        };
      }
      return state;
    }
    case SAVE_APPINTEGRATIONS_RESPONSE: {
      const newAppIntegrations = cloneDeep(state.appintegrations);
      const responses = Array.isArray(action.response) ? action.response : [action.response];
      const newSaveErrors = [];
      let error = false;

      responses.forEach((res) => {
        if(res.status === 'fulfilled') {
          if(res.value.success !== true) {
            error = {
              message: action.response,
              action: action.action,
            };
          } else {
            const appIntegrationToUpdate = newAppIntegrations.find((x) => x.gid === res.value.requestBody.resource_id);
            if (res.value.added_translations) {
              if (res.value.added_translations.errors?.errors?.length > 0) {
                newSaveErrors.push(cloneDeep(res.value.added_translations.errors));
                res.value.added_translations.errors.errors.forEach((error) => {
                  const translation = appIntegrationToUpdate.translations.find((t) => t.key === error.object_key);
                  if (translation) {
                    translation.error = true;
                    translation.restore = translation.target;
                    translation.target = res.value.requestBody.translations.find((t) => t.key === error.object_key)?.value || '';
                    appIntegrationToUpdate.hasError = true;
                  }
                });
              }
              res.value.added_translations.data.translationsRegister.translations.forEach((t) => {
                const translation = appIntegrationToUpdate.translations.find((tr) => tr.key === t.key);
                if (translation) translation.target = t.value;
              });
            }
            appIntegrationToUpdate.progress = _getAttributeProgress(appIntegrationToUpdate.translations, 'target');
          }
        }
      });

      return {
        ...state,
        appintegrations: newAppIntegrations,
        save_appintegrations_pending: false,
        error: error,
        saveErrors: newSaveErrors,
      };
    }

    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
        saveErrors: [],
      };
    }




    case LOAD_PARTNERS_PENDING: {
      return {
        ...state,
        load_partners_pending: true,
      };
    }
    case LOAD_PARTNERS_RESPONSE: {
      return {
        ...state,
        load_partners_pending: false,
        partners: action.response?.partners || [],
      };
    }

    case LOAD_PARTNER_INTEGRATION_PENDING: {
      return {
        ...state,
        load_partner_integration_pending: true,
      };
    }
    case LOAD_PARTNER_INTEGRATION_RESPONSE: {
      return {
        ...state,
        load_partner_integration_pending: false,
        partnerIntegration: action.response?.integration || null,
      };
    }

    case SAVE_PARTNER_APIKEY_PENDING: {
      return {
        ...state,
        save_partner_apikey_pending: true,
        partnerIntegrationError: null,
        loadingPartnerSlug: action.partnerSlug,
      };
    }
    case SAVE_PARTNER_APIKEY_RESPONSE: {
      const updatedPartners = cloneDeep(state.partners);
      const partnerToUpdate = updatedPartners.find(p => p.slug === action.partnerSlug);

      // Only update if the API call was successful
      if (partnerToUpdate && action.response?.success === true) {
        partnerToUpdate.partnerIntegration.integration = action.response?.data || null;
      }

      return {
        ...state,
        save_partner_apikey_pending: false,
        partnerIntegration: action.response?.success === true ? (action.response?.data || null) : state.partnerIntegration,
        partnerIntegrationError: action.response?.success === false ? action.response?.message : null,
        partners: updatedPartners,
        loadingPartnerSlug: null,
      };
    }

    case DELETE_PARTNER_APIKEY_PENDING: {
      return {
        ...state,
        delete_partner_apikey_pending: true,
        loadingPartnerSlug: action.partnerSlug,
      };
    }
    case DELETE_PARTNER_APIKEY_RESPONSE: {
      const updatedPartners = cloneDeep(state.partners);
      const partnerToUpdate = updatedPartners.find(p => p.slug === action.partnerSlug);
      if (partnerToUpdate) {
        partnerToUpdate.partnerIntegration.integration = null;
      }
      return {
        ...state,
        delete_partner_apikey_pending: false,
        partnerIntegration: null,
        partners: updatedPartners,
        loadingPartnerSlug: null,
      };
    }

    case ACTIVATE_PARTNER_INTEGRATION_PENDING: {
      return {
        ...state,
        activate_partner_integration_pending: true,
        partnerIntegrationError: null,
        loadingPartnerSlug: action.partnerSlug,
      };
    }
    case ACTIVATE_PARTNER_INTEGRATION_RESPONSE: {
      const updatedPartners = cloneDeep(state.partners);
      const partnerToUpdate = updatedPartners.find(p => p.slug === action.partnerSlug);

      // Only update if the API call was successful
      if (partnerToUpdate && action.response?.success === true) {
        partnerToUpdate.partnerIntegration.integration = action.response?.data || null;
      }

      return {
        ...state,
        activate_partner_integration_pending: false,
        partnerIntegration: action.response?.success === true ? (action.response?.data || null) : state.partnerIntegration,
        partnerIntegrationError: action.response?.success === false ? action.response?.message : null,
        partners: updatedPartners,
        loadingPartnerSlug: null,
      };
    }

    case DEACTIVATE_PARTNER_INTEGRATION_PENDING: {
      return {
        ...state,
        deactivate_partner_integration_pending: true,
        loadingPartnerSlug: action.partnerSlug,
      };
    }
    case DEACTIVATE_PARTNER_INTEGRATION_RESPONSE: {
      const updatedPartners = cloneDeep(state.partners);
      const partnerToUpdate = updatedPartners.find(p => p.slug === action.partnerSlug);
      if (partnerToUpdate) {
        partnerToUpdate.partnerIntegration.integration = null;
      }
      return {
        ...state,
        deactivate_partner_integration_pending: false,
        partnerIntegration: null,
        partners: updatedPartners,
        loadingPartnerSlug: null,
      };
    }


    default:
      return state;
  }
};







// ACTIONS CREATORS
export const resetErrors = () => {
  return (dispatch) => {
    dispatch({ type: RESET_ERRORS });
  };
};

export const loadAppIntegrations = (themeId, resetQuery = false, callback) => {
  return (dispatch) => {
    if (resetQuery) {
      dispatch({ type: LOAD_APPINTEGRATIONS_RESET_QUERY });
    }

    dispatch({ type: LOAD_APPINTEGRATIONS_PENDING });

    API.getAppEmbedsFromSettingsData(
      themeId,
      (response) => {
        dispatch({
          type: LOAD_APPINTEGRATIONS_RESPONSE,
          response,
          action: () => loadAppIntegrations(themeId, resetQuery, callback),
        });
        if (callback) callback(response);
      }
    );
  };
};

export const loadAppIntegration = (appIntegrationId, languageId, themeId, callback=()=>{}) => {
  return (dispatch) => {
    dispatch({ type: LOAD_APPINTEGRATION_PENDING });

    API.getAppEmbed(
      appIntegrationId,
      languageId,
      themeId,
      (response) => {
        dispatch({
          type: LOAD_APPINTEGRATION_RESPONSE,
          response,
          appIntegrationId,
          action: () => loadAppIntegration(appIntegrationId, languageId, themeId, callback),
        });
        if (callback) callback(response);
      }
    );
  };
};

export const saveAppIntegrations = (languageId, themeId, items, callback) => {
  return (dispatch) => {
    dispatch({ type: SAVE_APPINTEGRATIONS_PENDING });

    API.saveAppEmbeds(
      languageId,
      themeId,
      items,
      (progress, item) => {
        dispatch({ 
          type: SAVE_APPINTEGRATIONS_PROGRESS, 
          progress, 
          item 
        });
      },
      (response) => {
        dispatch({
          type: SAVE_APPINTEGRATIONS_RESPONSE,
          response,
          items,
          action: () => saveAppIntegrations(languageId, themeId, items, callback),
        });
        if (callback) callback(response);
      }
    );
  };
};




export const loadPartners = (callback) => {
  return (dispatch) => {
    dispatch({ type: LOAD_PARTNERS_PENDING });

    API.partnerGetAll((response) => {
      dispatch({
        type: LOAD_PARTNERS_RESPONSE,
        response,
      });
      if(callback) callback();
    });
  };
};

export const loadPartnerIntegration = (partner) => {
  return (dispatch) => {
    dispatch({ type: LOAD_PARTNER_INTEGRATION_PENDING });

    API.partnerGetIntegration(partner, (response) => {
      dispatch({
        type: LOAD_PARTNER_INTEGRATION_RESPONSE,
        response,
      });
    });
  };
};

export const savePartnerApiKey = (partner, apiKey) => {
  return (dispatch) => {
    dispatch({ type: SAVE_PARTNER_APIKEY_PENDING, partnerSlug: partner });

    API.partnerSetApiKey(partner, apiKey, (response) => {
      dispatch({
        type: SAVE_PARTNER_APIKEY_RESPONSE,
        response,
        partnerSlug: partner,
      });
    });
  };
};

export const deletePartnerApiKey = (partner) => {
  return (dispatch) => {
    dispatch({ type: DELETE_PARTNER_APIKEY_PENDING, partnerSlug: partner });

    API.partnerDeleteApiKey(partner, (response) => {
      dispatch({
        type: DELETE_PARTNER_APIKEY_RESPONSE,
        response,
        partnerSlug: partner,
      });
    });
  };
};

export const activatePartnerIntegration = (partner) => {
  return (dispatch) => {
    dispatch({ type: ACTIVATE_PARTNER_INTEGRATION_PENDING, partnerSlug: partner });

    API.activatePartnerIntegration(partner, (response) => {
      dispatch({
        type: ACTIVATE_PARTNER_INTEGRATION_RESPONSE,
        response,
        partnerSlug: partner,
      });
    });
  };
};

export const deactivatePartnerIntegration = (partner) => {
  return (dispatch) => {
    dispatch({ type: DEACTIVATE_PARTNER_INTEGRATION_PENDING, partnerSlug: partner });

    API.deletePartnerIntegration(partner, (response) => {
      dispatch({
        type: DEACTIVATE_PARTNER_INTEGRATION_RESPONSE,
        response,
        partnerSlug: partner,
      });
    });
  };
};
